import { CopyLinkModal } from '@design-system/components/modals/CopyLinkModal';

export const WorkoutLinkModal = (p: {
  isOpen: boolean;
  url: string;
  onClose: () => void;
}) => {
  return (
    <CopyLinkModal
      isOpen={p.isOpen}
      onClose={p.onClose}
      url={p.url}
      title="Share your workout"
      linkTitle="Workout Deep Link"
      linkDesc="This link will bring a user straight to a specific workout. It will Gift them this single workout if they don't already have access. "
      desc="It's ready for use in your email campaigns, social media posts, and more!"
    />
  );
};
